import { css } from 'linaria';

export const relatedProductsTitle = css`
  width: 100%;
  margin-bottom: 32px;

  @media (--to-desktop) {
    margin-bottom: 16px;
  }
`;

export const relatedProductsSlide = css`
  && {
    width: 377px;
    margin-right: 24px;
    height: auto;

    @media (--only-desktop) {
      width: 297px;
    }

    @media (--only-tablet) {
      width: 318px;
    }

    @media (--only-mobile) {
      width: 100%;
      margin-right: 11px;
    }
  }
`;

export const relatedProductsCard = css`
  display: flex;
  height: 100%;
  flex-direction: column;
`;

export const relatedProductsCardImageWrapper = css`
  height: 269px;
  margin-bottom: 16px;
  border-radius: var(--rounding-xl);

  @media (--to-largeDesktop) {
    margin-bottom: 12px;
  }

  @media (--only-desktop) {
    height: 213px;
  }

  @media (--only-tablet) {
    height: 227px;
  }

  @media (--only-mobile) {
    height: 206px;
  }
`;

export const relatedProductsCardImage = css`
  border-radius: var(--rounding-xl);
  height: 100%;
  width: 100%;
  object-fit: cover;
`;
